module.exports = __webpack_public_path__ + "static/media/linemessenger.62e83cd7.svg";